module.exports = __webpack_public_path__ + "static/media/float.c2baa75c.jpg";